<mat-icon *ngIf="isCurrentPlan || isFuturePlan" [class.green]="isCurrentPlan"
    [class.orange]="isFuturePlan">circle</mat-icon>